import { useRef } from 'react'
import IconButton from './IconButton'
import './ClearableInput.css'

function ClearableInput({
  value,
  onValueChange,
  clearLabel,
  className = '',
  inputClassName = '',
  disabled = false,
  type = 'text',
  ...inputProps
}) {
  const inputRef = useRef(null)
  const hasValue = value !== null && value !== undefined && String(value).length > 0
  const resolvedClearLabel = clearLabel || (type === 'search' ? 'Suche zurücksetzen' : 'Eingabe löschen')

  const handleClear = () => {
    onValueChange('')
    inputRef.current?.focus()
  }

  return (
    <span className={`clearable-input${className ? ` ${className}` : ''}`}>
      <input
        {...inputProps}
        ref={inputRef}
        type={type}
        className={inputClassName}
        value={value}
        onChange={(event) => onValueChange(event.target.value)}
        disabled={disabled}
      />
      {hasValue && !disabled && (
        <IconButton
          icon="close"
          label={resolvedClearLabel}
          variant="quiet"
          className="clearable-input__clear"
          onClick={handleClear}
        />
      )}
    </span>
  )
}

export default ClearableInput
